import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AsyncStorageProvider } from '../support/AsyncStorageProvider';
import { HELPER_BEE_OPENED_STORAGE_KEY } from './BeeChatViewModel';

export const BeaChatDevTools: React.FC = () => {
    const storageProvider = useInstance(AsyncStorageProvider);

    const clearBeaOpenedFlag = async () => {
        await storageProvider.getBooleanProvider(HELPER_BEE_OPENED_STORAGE_KEY).remove();
        window.location.reload();
    };

    return (
        <div style={{ marginBottom: '8px' }}>
            <IonButton
                fill="outline"
                size="small"
                onClick={clearBeaOpenedFlag}
            >
                Reset "Has Opened Bea Chat" Flag
            </IonButton>
        </div>
    );
};
